import { analytics } from '../firebaseConfig';
import { logEvent } from 'firebase/analytics';
import { isCodexUi } from './codexEnv';
import { isDevelopment } from '../config/env';

// Logger utility to handle console logs based on environment

const logger = {
    log: (...args) => {
        if (isDevelopment) {
            console.log(...args);
        }
    },
    error: (message, error) => {
        // Always log errors, even in production
        console.error(message, error);
        
        // Log error to analytics
        if (!isCodexUi && analytics) {
            logEvent(analytics, 'error_occurred', {
                error_message: message,
                error_details: error?.message || error,
                error_stack: error?.stack,
                environment: isDevelopment ? 'development' : 'production'
            });
        }
    },
    warn: (message, error) => {
        if (isDevelopment) {
            console.warn(message, error);
        }
        
        // Log warning to analytics
        if (!isCodexUi && analytics) {
            logEvent(analytics, 'warning_occurred', {
                warning_message: message,
                warning_type: error?.name || 'unknown',
                warning_stack: error?.stack,
                timestamp: new Date().toISOString()
            });
        }
    },
    info: (message) => {
        if (isDevelopment) {
            console.info(message);
        }
    },
    debug: (...args) => {
        if (isDevelopment) {
            console.debug(...args);
        }
    }
};

export default logger; 
